const noopConsume = async (src) => {
    // eslint-disable-next-line no-underscore-dangle
    for await (const _msg of src) {
        // noop, just consume
    }
};
/**
 * Similar to Array#forEach or Stream.PassThrough.
 * Allows inspection of a pipeline without mutating it.
 * Note: Pipeline will block until forEach call resolves.
 */
export async function* forEach(src, fn, onError) {
    let index = 0;
    for await (const v of src) {
        try {
            await fn(v, index, src);
        }
        catch (err) {
            if (onError) {
                await onError(err, v);
                continue;
            }
            else {
                throw err;
            }
        }
        finally {
            index += 1;
        }
        yield v;
    }
}
/**
 * Similar to Array#map or Stream.Transform.
 */
export async function* map(src, fn, onError) {
    let index = 0;
    for await (const v of src) {
        try {
            yield await fn(v, index, src);
        }
        catch (err) {
            if (onError) {
                await onError(err, v);
                continue;
            }
            else {
                throw err;
            }
        }
        finally {
            index += 1;
        }
    }
}
/**
 * Similar to Array#filter
 */
export async function* filter(src, fn, onError) {
    let index = 0;
    for await (const v of src) {
        let ok;
        try {
            ok = await fn(v, index, src);
        }
        catch (err) {
            if (onError) {
                await onError(err, v);
                continue;
            }
            else {
                throw err;
            }
        }
        finally {
            index += 1;
        }
        if (ok) {
            yield v;
        }
    }
}
/**
 * Start consuming generator.
 * Takes optional forEach function.
 */
export async function consume(src, fn = (v) => v, onError) {
    return noopConsume(forEach(src, fn, onError));
}
export async function* unique(source, getIdentity) {
    const seenIdentities = new Set();
    for await (const item of source) {
        const identity = getIdentity(item);
        if (!seenIdentities.has(identity)) {
            seenIdentities.add(identity);
            yield item;
        }
    }
}
export const fromArray = async function* (items) {
    for (const item of items) {
        yield item;
    }
};
export const transformError = async function* (src, transformFn) {
    try {
        for await (const item of src) {
            yield item;
        }
    }
    catch (err) {
        throw await transformFn(err);
    }
};
//# sourceMappingURL=GeneratorUtils.js.map